import React, { Component, useEffect, useState } from 'react';
import LaravelApi from '../laravelApi/LaravelApi';

const BlogAdmin = () => {
  const [logged, setLogged] = useState(null);
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);

  useEffect(() => {
    if (window.localStorage.getItem('dpl-be-access-token')) {
      setLogged("Token found!");
    }
  });

  const usernameChange = (event) => {
    setUsername(event.target.value);
  }

  const passwordChange = (event) => {
    setPassword(event.target.value);    
  }

  const handleSubmit = (event) => {
    getAccess();
    event.preventDefault();
  }

  const getAccess = async () => {
    const response = await LaravelApi.post('/auth/login', {
        email: username,
        password: password,
        remember_me: true
      }, {withCredentials: true}
    );
    if (response.status == 200) {
      window.localStorage.setItem('dpl-be-access-token', response.data.access_token)
    }
  }

  return (
    <div>
      {logged}
      <form onSubmit={handleSubmit}>
      <label>
        Username:
        <input type="text" value={username} onChange={usernameChange} />
      </label>
      <label>
        Password:
        <input type="password" value={password} onChange={passwordChange} />
      </label>
      <input type="submit" value="Submit" />   
    </form>
    </div>
  );
}

export default BlogAdmin;
